import { Outlet } from 'react-router-dom';

/**
 * 活动模块父级布局：仅渲染子路由出口，URL 仍为 /activities、/activities/:id 等。
 */
export default function ActivitiesShell() {
  return <Outlet />;
}
